import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Select, TimePicker, Modal } from "antd";
import { API_UUPDATE_LAUNDRY_MEN } from "api/laundry-management";
import moment from "moment";
import { API_UPLOAD_CNIC_LAUNDRY_MEN } from "api/laundry-management";
import { API_UPLOAD_LICENSE_LAUNDRY_MEN } from "api/laundry-management";
import { API_LIST_STORE } from "api/store-managemnt";
import { API_UPDATE_LAUNDRY_MEN } from "api/laundry-management";
import { API_UPLOAD_PROFILE_PIC_LAUNDRY_MEN } from "api/laundry-management";
import { CONSTANTS } from "config/constant";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { MdOutlineArrowBack } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

const { Option } = Select;

const EditLaundryMan = () => {
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedTimes, setSelectedTimes] = useState({});
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [image, setImage] = useState("");
  const [data, setData] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [drivertype, setDriverType] = useState("");
  const [selectedOption, setSelectedOption] = useState(null); // State to hold the selected option

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10, // Adjust the page size according to your needs
    totalPages: 1, // Initialize totalPages with 1
  });
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([
    // {
    //   uid: "-1",
    //   name: "image.png",
    //   status: "done",
    //   url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    // },
  ]);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // State for modal visibility
  const [valuesData, setValuesData] = useState(); // State for modal visibility
  const { t } = useTranslation();
  const Navigate = useNavigate();

  const fileInputRef = useRef(null);
  const cnic_front_ref = useRef(null);
  const cnic_back_ref = useRef(null);
  const license_front_ref = useRef(null);
  const license_back_ref = useRef(null);
  const location = useLocation();
  const driver = location.state && location.state.data;
  console.log("driver", driver);

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChanges = ({ fileList: newFileList }) => {
    console.log(newFileList, "newFilelist");
    setFileList(newFileList);
    if (!newFileList?.length > 0) {
      setImage("");
    }
  };
  console.log(fileList, "lflasdjy93oldhfk");
  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      // Create a FormData object
      const formData = new FormData();
      formData.append("images", file);
      const response = await API_UPLOAD_PROFILE_PIC_LAUNDRY_MEN(formData);

      console.log("result132132131", response, file);
      // Handle success
      const newFileList = [
        {
          uid: response.id, // Replace with the unique ID you receive from the server
          name: response?.file?.[0]?.name,
          status: "done",
          url: CONSTANTS?.IMG_DIRECTORY + response?.file?.[0]?.file_url, // Replace with the URL of the uploaded image
          // image:'iamfilelist'
        },
      ];

      console.log(newFileList, "iamfilelist");
      setFileList(newFileList);
      setImage(response?.file?.[0]);
      onSuccess();
      toast.success(response?.message);

      console.log("result", response);
      console.log("newFileList", newFileList);
    } catch (error) {
      toast.error(error?.message);
      // Handle exceptions and errors
      console.log("error", error);
      onError(error);
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("Upload")}
      </div>
    </button>
  );
  //<<<<<<<<<<<<<<<<<<----------------------- OLD ----------------------->>>>>>>>>>>>

  // Function to handle day selection
  // const handleDaySelect = (days) => {
  //   setSelectedDays(days);
  //   const updatedTimes = {};
  //   days.forEach((day) => {
  //     if (!selectedTimes[day]) {
  //       updatedTimes[day] = { start: null, end: null };
  //     } else {
  //       updatedTimes[day] = selectedTimes[day];
  //     }
  //   });
  //   setSelectedTimes(updatedTimes);
  // };
  // // Function to handle start time selection for a specific day
  // const handleStartTimeSelect = (day, time) => {
  //   const updatedTimes = { ...selectedTimes };
  //   updatedTimes[day].start = time;
  //   setSelectedTimes(updatedTimes);
  // };

  // // Function to handle end time selection for a specific day
  // const handleEndTimeSelect = (day, time) => {
  //   const updatedTimes = { ...selectedTimes };
  //   updatedTimes[day].end = time;
  //   setSelectedTimes(updatedTimes);
  // };

  //<<<<<<<<<<<<<<<<<<----------------------- New ----------------------->>>>>>>>>>>>

  // Function to handle day selection

  const handleDaySelect = (days) => {
    setSelectedDays(days);

    // Create a new updatedTimes object with only the currently selected days
    const updatedTimes = {};

    days.forEach((day) => {
      // If the day is selected, either keep the existing value or initialize it
      updatedTimes[day] = selectedTimes[day] || { start: null, end: null };
    });

    // Update state with the new object
    setSelectedTimes(updatedTimes);
  };
  // const handleDaySelect = (days) => {
  //   setSelectedDays(days);
  //   const updatedTimes = { ...selectedTimes };
  //   days.forEach((day) => {
  //     if (!updatedTimes[day]) {
  //       updatedTimes[day] = { start: null, end: null };
  //     }
  //   });
  //   setSelectedTimes(updatedTimes);
  // };
  console.log(selectedDays, selectedTimes, "selectedDays");
  // Function to handle start time selection for a specific day
  const handleStartTimeSelect = (day, time) => {
    // const updatedTimes = { ...selectedTimes };
    // updatedTimes[day] = { ...updatedTimes[day], start: time?.format("HH:mm") };
    // setSelectedTimes(updatedTimes);
    setSelectedTimes((prevTimes) => ({
      ...prevTimes,
      [day]: {
        ...prevTimes[day],
        start: time ? time : null,
      },
    }));
  };

  // Function to handle end time selection for a specific day
  const handleEndTimeSelect = (day, time) => {
    // const updatedTimes = { ...selectedTimes };
    // updatedTimes[day] = { ...updatedTimes[day], end: time };
    // setSelectedTimes(updatedTimes);
    setSelectedTimes((prevTimes) => ({
      ...prevTimes,
      [day]: {
        ...prevTimes[day],
        end: time ? time : null,
      },
    }));
  };
  console.log(image, "l787h,2b,nghfahjgfkhj");
  // Function to upload CNIC images
  const uploadCNICImagesFront = async (imageFile, imageType, setFieldValue) => {
    try {
      const formData = new FormData();
      formData.append("images", imageFile);
      const response = await API_UPLOAD_CNIC_LAUNDRY_MEN(formData);
      console.log("CNIC image uploaded successfully:", response);
      setFieldValue("cnic_front_image", [response?.file?.[0]?.file_url]);
      toast.success(response?.message);
    } catch (error) {
      console.error("Error uploading CNIC image:", error);
      toast.error("Error uploading CNIC image");
    }
  };
  // Function to Licence CNIC images
  const uploadLicenceImagesFront = async (
    imageFile,
    imageType,
    setFieldValue
  ) => {
    try {
      const formData = new FormData();
      formData.append("images", imageFile);
      const response = await API_UPLOAD_LICENSE_LAUNDRY_MEN(formData);
      setFieldValue("license_front_image", [response?.file?.[0]?.file_url]);
      console.log("CNIC image uploaded successfully:", response);
      toast.success(response?.message);
    } catch (error) {
      console.error("Error uploading CNIC image:", error);
      toast.error("Error uploading CNIC image");
    }
  };

  const uploadCNICImagesBack = async (imageFile, imageType, setFieldValue) => {
    try {
      const formData = new FormData();
      formData.append("images", imageFile);
      const response = await API_UPLOAD_CNIC_LAUNDRY_MEN(formData);
      console.log("CNIC image uploaded successfully:", response);
      setFieldValue("cnic_back_image", [response?.file?.[0]?.file_url]);

      toast.success(response?.message);
    } catch (error) {
      console.error("Error uploading CNIC image:", error);
      toast.error("Error uploading CNIC image");
    }
  };
  // Function to Licence CNIC images
  const uploadLicenceImagesBack = async (
    imageFile,
    imageType,
    setFieldValue
  ) => {
    try {
      const formData = new FormData();
      formData.append("images", imageFile);
      const response = await API_UPLOAD_LICENSE_LAUNDRY_MEN(formData);
      setFieldValue("license_back_image", [response?.file?.[0]?.file_url]);
      console.log("CNIC image uploaded successfully:", response);
      toast.success(response?.message);
    } catch (error) {
      console.error("Error uploading CNIC image:", error);
      toast.error("Error uploading CNIC image");
    }
  };

  // const fetchData = async () => {
  //   try {
  //     const params = {};
  //     const newData = await API_LIST_STORE(params);
  //     console.log("provider", newData);
  //     setData(newData?.providers);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };
  // useEffect(() => {
  //   fetchData();
  // }, []);
  const fetchData = async (page) => {
    try {
      setLoading(true);
      const params = {
        page: page,
        limit: pagination.pageSize,
        name: "",
      };
      const newData = await API_LIST_STORE(params);
      setData((prevData) => [...prevData, ...newData.providers]);
      setPagination((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.total_pages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pagination.current);
  }, [pagination.current]);

  const handleScroll = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (pagination.current < pagination.totalPages) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          current: prevPagination.current + 1,
        }));
      }
    }
  };
  useEffect(() => {
    const newData = [driver?.provider_info];
    // setDatas(newData);
    // If there's a pre-selected laundry option available in data, set it as the selected option
    console.log("newData", newData);
    const preSelectedOption = newData.find(
      (option) => option?._id === driver?.provider
    );
    console.log("preSelectedOption", preSelectedOption);

    if (preSelectedOption) {
      console.log("preSelectedOption", preSelectedOption);
      setSelectedOption(preSelectedOption);
    }
  }, []);

  useEffect(() => {
    if (driver?.profile_image?.[0]?.file_url) {
      setFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: CONSTANTS?.IMG_DIRECTORY + driver?.profile_image?.[0]?.file_url,
        },
      ]);
    }
    setImage(driver?.profile_image);
  }, []);

  // Set initial state based on fetched data
  useEffect(() => {
    const initialSelectedDays = driver?.availability?.map((data) => data?.day);
    setSelectedDays(initialSelectedDays);

    const initialSelectedTimes = {};
    driver?.availability.forEach((data) => {
      initialSelectedTimes[data.day] = {
        start: moment.unix(data.start_time),
        end: moment.unix(data.end_time),
      };
    });
    setSelectedTimes(initialSelectedTimes);
  }, [driver?.availability]);

  useEffect(() => {
    setDriverType(driver?.laundry_man_type);
  }, [driver?.laundry_man_type]);
  console.log("data >>", driver);
  console.log("driver type >>", fileList);
  console.log("image ===>", image);

  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              first_name: driver?.first_name,
              last_name: driver?.last_name,
              email: driver?.email,
              password: driver?.unhashed_password,
              phone_no: driver?.phone_no,
              // provider: driver?.provider,
              cnic_front_image: driver?.cnic_front_image,
              cnic_back_image: driver?.cnic_back_image,
              license_front_image: driver?.license_front_image,
              license_back_image: driver?.license_back_image,
              vehicle_number: driver?.vehicle_number,
              vehicle_type: driver?.vehicle_type,
              pickup_order_rate: driver?.pickup_order_rate,
              delivery_order_rate: driver?.delivery_order_rate,
              // profile_image: driver?.profile_image?.[0]?.file_url,
              // dispatch_order_rate: driver?.dispatch_order_rate,
              availability: [],
              driving_license_number: driver?.driving_license_number,
              laundry_man_type: driver?.laundry_man_type,
              pickup_order_rate_from_laundrybox:
                driver?.pickup_order_rate_from_laundrybox,
              pickup_order_rate_from_laundry_to_store:
                driver?.pickup_order_rate_from_laundry_to_store,
              pickup_order_rate_from_store_to_laundry:
                driver?.pickup_order_rate_from_store_to_laundry,
            }}
            validationSchema={Yup.object({
              first_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              last_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              email: Yup.string()
                .email("Invalid email format")
                .matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email format"
                )
                .test("valid-domain", "Invalid email format", function (value) {
                  if (!value) return true; // Skip if empty
                  const domain = value.split("@")[1]; // Extract domain part
                  return !!domain && /\./.test(domain); // Check for dot in domain part
                })
                .max(40, "Maximum character long before @")
                .required("Required"),
              // password: Yup.string().required("Required"),
              phone_no: Yup.string()
                .required("Required")
                .length(12, "please enter correct Phone number"),
              // provider: Yup.string().required("Required"),
              cnic_front_image: Yup.array().min(1, "Required"),
              cnic_back_image: Yup.array().min(1, "Required"),
              license_front_image: Yup.array().min(1, "Required"),
              license_back_image: Yup.array().min(1, "Required"),
              vehicle_number: Yup.string().required("Required"),
              vehicle_type: Yup.string().required("Required"),
              pickup_order_rate: Yup.number().required("Required"),
              delivery_order_rate: Yup.number().required("Required"),
              // dispatch_order_rate: Yup.number().required("Required"),
              driving_license_number: Yup.string().required("Required"),
              // availability: Yup.array()
              //   .min(1, "Please select at least one day")
              //   .required("Please select at least one day"),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              console.log("values", values);
              setValuesData(values);
              setConfirmModalVisible(true);
              // try {
              //   // Format availability data for payload
              //   const formattedAvailability = Object.keys(selectedTimes).map(
              //     (day) => ({
              //       day,
              //       start_time: selectedTimes[day].start
              //         ? selectedTimes[day].start.unix()
              //         : "",
              //       end_time: selectedTimes[day].end
              //         ? selectedTimes[day].end.unix()
              //         : "",
              //     })
              //   );

              //   // Merge formatted availability into form values
              //   const payload = {
              //     ...values,
              //     availability: formattedAvailability,
              //   };

              //   // Call API with payload
              //   const userData = await API_UPDATE_LAUNDRY_MEN(
              //     payload,
              //     driver?._id
              //   );
              //   Navigate("/admin/laundryman-management/laundryman-tables");

              //   toast.success(userData?.message);
              // } catch (error) {
              //   console.error("error", error);
              //   toast.error(error?.response?.data?.message);
              // } finally {
              //   setSubmitting(false);
              // }
            }}
          >
            {({
              isSubmitting,
              errors,
              values,
              setFieldValue,
              handleChange,
            }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                {/* {JSON?.stringify({errors})} */}
                <div
                  className="flex cursor-pointer items-center gap-2"
                  onClick={() => {
                    Navigate(-1);
                  }}
                >
                  <MdOutlineArrowBack
                    className="cursor-pointer"
                    style={{ fontSize: "17px" }}
                  />
                  <p>{t("Back")}</p>
                </div>
                <div className="mb-3 flex justify-center">
                  <Upload
                    action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                    listType="picture-circle"
                    customRequest={customRequest}
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChanges}
                  >
                    {fileList.length == 1 ? null : uploadButton}
                  </Upload>
                  {previewImage && (
                    <Image
                      wrapperStyle={{
                        display: "none",
                      }}
                      preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) =>
                          !visible && setPreviewImage(""),
                      }}
                      src={previewImage}
                    />
                  )}
                </div>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("First Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("First Name")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="first_name"
                        placeholder={t("First Name")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="first_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Last Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Last Name")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="last_name"
                        placeholder={t("Last Name")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="last_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Email")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Email")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="email"
                        placeholder={t("Email")}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  {/* <Col span={8}>
                    <div className="relative mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Password")}
                        <span className="text-[red]">*</span>
                      </label>
             

                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder={t("Password")}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((prevState) => !prevState)
                        }
                        className="absolute bottom-[-20px] right-4 top-3"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                      </button>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col> */}

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Phone No")}
                        <span className="text-[red]">*</span>
                      </label>

                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Phone No")}
                      </label> */}
                      {/* <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="number"
                        name="phone_number"
                        placeholder={t("Phone No")}
                      /> */}
                      <PhoneInput
                        country={"sa"}
                        disableDropdown={true}
                        onlyCountries={["sa"]}
                        countryCodeEditable={false}
                        autoFormat={true}
                        enableLongNumbers={false}
                        // className="w-100 mt-2"
                        inputProps={{
                          name: "phone_no",
                          className:
                            "bg-transparent pl-[3rem] peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500",

                          placeholder: "Phone No",
                          onKeyPress: (e) => {
                            const currentValue = values?.phone_no || "";
                            const digitsOnly = currentValue?.replace(/\D/g, ""); // Remove non-numeric characters

                            // Prevent input if there are already 12 digits
                            if (digitsOnly?.length >= 12 && /\d/?.test(e.key)) {
                              e.preventDefault();
                            }
                          },
                        }}
                        value={values?.phone_no}
                        onChange={(value) => {
                          setFieldValue("phone_no", value);
                        }}
                      />
                      <ErrorMessage
                        name="phone_no"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  {/* <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Provider")}
                        <span className="text-[red]">*</span>
                      </label>
                 
                      <Field name="Provider">
                        {({ field }) => (
                          <Select
                            // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none "
                            className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                            {...field}
                            showSearch
                            placeholder="Select Laundry"
                            optionFilterProp="children"
                            onPopupScroll={handleScroll}
                            // value={selectedOption}
                            value={
                              selectedOption
                                ? selectedOption.store_name
                                : undefined
                            }
                            filterOption={(input, option) =>
                              option?.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            loading={loading}
                            onChange={(value) => {
                              const selected = data?.find(
                                (item) => item?._id === value
                              );
                              console.log("selected ==>", selected);
                              setSelectedOption(selected);
                              setFieldValue("Provider", selected?._id);
                              // setFieldValue("laundry", value);
                              // setTouched({ laundry: true });
                            }}
                          >
                            {data?.map((item) => (
                              <Option key={item._id} value={item?._id}>
                                {item.store_name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Field>
                      <ErrorMessage
                        name="provider"
                        component="div"
                        className="text-red-500"
                      />
                    </div> */}

                  <Col span={8}>
                    {/* <div className="mb-3">
                      <label>
                        {" "}
                        CNIC Front Image<span className="text-[red]">*</span>
                      </label>
                      <input
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="file"
                        name="cnic_front_image"
                        onChange={(event) => {
                          setFieldValue(
                            "cnic_front_image",
                            event.currentTarget.files[0]
                          );
                          uploadCNICImagesFront(
                            event.currentTarget.files[0],
                            "cnic_front",
                            setFieldValue
                          );
                        }}
                      />

                      <ErrorMessage
                        name="cnic_front_image"
                        component="div"
                        className="text-red-500"
                      />
                    </div> */}
                    {/* {console.log(values?.cnic_front_image, "cnicfrontimages")} */}
                    {console.log("errorsdsdsafsdfsdfsdfsd",errors)}
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("CNIC Front Image")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("CNIC Front Image")}
                      </label> */}
                      <input
                        // className="hidden"
                        className="bg-transparent peer hidden w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="file"
                        name="cnic_front_image"
                        onChange={(event) => {
                          // console.log(event?.currentTarget?.files[0],)
                          setFieldValue(
                            "cnic_front_image",
                            event.currentTarget.files[0]
                          );
                          uploadCNICImagesFront(
                            event.currentTarget.files[0],
                            "cnic_front",
                            setFieldValue
                          );
                        }}
                        ref={cnic_front_ref}
                      />
                      <div
                        className="mt-2 flex h-11 w-full cursor-pointer items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onClick={() => cnic_front_ref.current.click()}
                      >
                        {values?.cnic_front_image?.length > 0
                          ? `Image.${values?.cnic_front_image?.[0]?.file_type}`
                          : t("CNIC Front Image")}
                      </div>

                      <ErrorMessage
                        name="cnic_front_image"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("CNIC Back Image")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("CNIC Back Image")}
                      </label> */}
                      {/* <input
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="file"
                        name="cnic_back_image"
                        onChange={(event) => {
                          setFieldValue(
                            "cnic_back_image",
                            event.currentTarget.files[0]
                          );
                          uploadCNICImagesBack(
                            event.currentTarget.files[0],
                            "cnic_back",
                            setFieldValue
                          );
                        }}
                      /> */}
                      <input
                        // className="hidden"
                        className="bg-transparent peer hidden w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="file"
                        name="cnic_back_image"
                        onChange={(event) => {
                          setFieldValue(
                            "cnic_back_image",
                            event.currentTarget.files[0]
                          );
                          uploadCNICImagesBack(
                            event.currentTarget.files[0],
                            "cnic_back_image",
                            setFieldValue
                          );
                        }}
                        ref={cnic_back_ref}
                      />
                      <div
                        className="mt-2 flex h-11 w-full cursor-pointer items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onClick={() => cnic_front_ref.current.click()}
                      >
                        {values?.cnic_back_image?.length > 0
                          ? `Image.${values?.cnic_back_image?.[0]?.file_type}`
                          : t("CNIC Back Image")}{" "}
                      </div>
                      {/* <div
                        className="mt-2 flex h-11 w-full cursor-pointer items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onClick={() => cnic_back_ref.current.click()}
                      >
                        Upload CNIC Back Image
                      </div> */}
                      <ErrorMessage
                        name="cnic_back_image"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("License Front Image")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("License Front Image")}
                      </label> */}
                      <input
                        // className="hidden"
                        className="bg-transparent peer hidden w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="file"
                        name="license_front_image"
                        onChange={(event) => {
                          setFieldValue(
                            "license_front_image",
                            event.currentTarget.files[0]
                          );
                          uploadLicenceImagesFront(
                            event.currentTarget.files[0],
                            "license_front_image",
                            setFieldValue
                          );
                        }}
                        ref={license_front_ref}
                      />
                      <div
                        className="mt-2 flex h-11 w-full cursor-pointer items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onClick={() => license_front_ref.current.click()}
                      >
                        {values?.license_front_image?.length > 0
                          ? `Image.${values?.license_front_image?.[0]?.file_type}`
                          : t("License Front Image")}{" "}
                      </div>
                      {/* <input
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="file"
                        name="license_front_image"
                        onChange={(event) => {
                          setFieldValue(
                            "license_front_image",
                            event.currentTarget.files[0]
                          );
                          uploadLicenceImagesFront(
                            event.currentTarget.files[0],
                            "license_front",
                            setFieldValue
                          );
                        }}
                      /> */}

                      <ErrorMessage
                        name="license_front_image"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("License Back Image")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("License Back Image")}{" "}
                      </label> */}
                      {/* <input
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="file"
                        name="license_back_image"
                        onChange={(event) => {
                          setFieldValue(
                            "license_back_image",
                            event.currentTarget.files[0]
                          );
                          uploadLicenceImagesBack(
                            event.currentTarget.files[0],
                            "license_back",
                            setFieldValue
                          );
                        }}
                      /> */}
                      <input
                        // className="hidden"
                        className="bg-transparent peer hidden w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="file"
                        name="license_back_image"
                        onChange={(event) => {
                          setFieldValue(
                            "license_back_image",
                            event.currentTarget.files[0]
                          );
                          uploadLicenceImagesBack(
                            event.currentTarget.files[0],
                            "license_back_image",
                            setFieldValue
                          );
                        }}
                        ref={license_back_ref}
                      />
                      <div
                        className="mt-2 flex h-11 w-full cursor-pointer items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onClick={() => license_back_ref.current.click()}
                      >
                        {values?.license_back_image?.length > 0
                          ? `Image.${values?.license_back_image?.[0]?.file_type}`
                          : t("License Back Image")}
                      </div>
                      <ErrorMessage
                        name="license_back_image"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Vehicle Number")}
                        <span className="text-[red]">*</span>
                      </label>

                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="vehicle_number"
                        placeholder={t("Vehicle Number")}
                      />
                      <ErrorMessage
                        name="vehicle_number"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Vehicle Type")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name={t("vehicle_type")}
                        placeholder={t("Vehicle Type")}
                      />
                      <ErrorMessage
                        name="vehicle_type"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Driver Type")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as="select"
                        className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        name="laundry_man_type"
                        onChange={(e) => {
                          setDriverType(e.target.value);
                          setFieldValue("laundry_man_type", e.target.value);
                        }}
                        value={drivertype}
                      >
                        <option value="" disabled>
                          {t("Select Driver Type")}
                        </option>{" "}
                        <option value="car_driver">{t("Car")}</option>{" "}
                        {/* Option for car */}
                        <option value="truck_driver">{t("Truck")}</option>{" "}
                        {/* Option for truck */}
                      </Field>
                      <ErrorMessage
                        name="laundry_man_type"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Pickup Order Rate")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="pickup_order_rate"
                        placeholder={t("Pickup Order Rate")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="pickup_order_rate"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Delivery Order Rate")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="delivery_order_rate"
                        placeholder={t("Delivery Order Rate")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="delivery_order_rate"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  {/* new fields */}
                  {values?.laundry_man_type === "truck_driver" && (
                    <Col span={8}>
                      <div className="mb-3">
                        <label className="font-semibold">
                          {" "}
                          {t("Pickup Order Rate from store to laundry")}
                          <span className="text-[red]">*</span>
                        </label>

                        <Field
                          className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                          type="text"
                          name="pickup_order_rate_from_store_to_laundry"
                          placeholder={t(
                            "Pickup Order Rate from store to laundry"
                          )}
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which;
                            const keyValue = String.fromCharCode(keyCode);
                            const regex = /^[0-9]+$/;
                            if (!regex.test(keyValue)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <ErrorMessage
                          name="pickup_order_rate_from_store_to_laundry"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>
                  )}

                  {values?.laundry_man_type === "truck_driver" && (
                    <Col span={8}>
                      <div className="mb-3">
                        <label className="font-semibold">
                          {" "}
                          {t("Pickup Order Rate from laundry to Store")}
                          <span className="text-[red]">*</span>
                        </label>
                        <Field
                          className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                          type="text"
                          name="pickup_order_rate_from_laundry_to_store"
                          placeholder={t(
                            "Pickup Order Rate from laundry to store"
                          )}
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which;
                            const keyValue = String.fromCharCode(keyCode);
                            const regex = /^[0-9]+$/;
                            if (!regex.test(keyValue)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <ErrorMessage
                          name="pickup_order_rate_from_laundry_to_store"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>
                  )}

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Pickup Order Rate from laundrybox")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="pickup_order_rate_from_laundrybox"
                        placeholder={t("Pickup Order Rate from laundrybox")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="pickup_order_rate_from_laundrybox"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  {/* new fields */}
                  {/* <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Dispatch Order Rate")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="dispatch_order_rate"
                        placeholder={t("Dispatch Order Rate")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="dispatch_order_rate"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col> */}

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Driving License Number")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Driving License Number")}{" "}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="driving_license_number"
                        placeholder="Driving License Number"
                      />
                      <ErrorMessage
                        name="driving_license_number"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Availability")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Availability")}
                      </label> */}
                      <Select
                        name="days"
                        // className="mt-2 h-11 rounded-xl border bg-white p-3 text-sm outline-none"
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 py-2 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        mode="multiple"
                        placeholder={t("Availability")}
                        value={selectedDays}
                        onChange={handleDaySelect}
                        style={{ width: "100%" }}
                      >
                        <Option value="Monday">{t("Monday")}</Option>
                        <Option value="Tuesday">{t("Tuesday")}</Option>
                        <Option value="Wednesday">{t("Wednesday")}</Option>
                        <Option value="Thursday">{t("Thursday")}</Option>
                        <Option value="Friday">{t("Friday")}</Option>
                        <Option value="Saturday">{t("Saturday")}</Option>
                        <Option value="Sunday">{t("Sunday")}</Option>
                      </Select>

                      {selectedDays?.map((day) => (
                        <div key={day} style={{ marginTop: "1rem" }}>
                          <label>{day}:</label>
                          <br />
                          <div className="flex w-full flex-row items-center justify-between gap-2">
                            <Datetime
                              dateFormat={false}
                              timeFormat="h:mm A"
                              onChange={(time) =>
                                handleStartTimeSelect(day, time)
                              }
                              placeholder="Select time"
                              value={
                                selectedTimes[day]?.start
                                  ? selectedTimes[day]?.start
                                  : "Start time"
                              }
                            />
                            <Datetime
                              dateFormat={false}
                              timeFormat="h:mm A"
                              onChange={(time) =>
                                handleEndTimeSelect(day, time)
                              }
                              placeholder="Select time"
                              value={
                                selectedTimes[day]?.end
                                  ? selectedTimes[day]?.end
                                  : "End time"
                              }
                            />
                          </div>
                        </div>
                      ))}

                      <ErrorMessage
                        name="availability"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting ? t("Updating") + "..." : t("Update Driver")}

                    {/* {isSubmitting ? "Updating..." : " Update Driver"}{" "} */}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* Confirmation Modal */}
          <Modal
            // title="Save Changes"
            visible={confirmModalVisible}
            onCancel={() => setConfirmModalVisible(false)}
            centered
            onOk={async () => {
              setConfirmModalVisible(false);
              try {
                // Format availability data for payload
                const formattedAvailability = Object.keys(selectedTimes).map(
                  (day) => ({
                    day,
                    start_time: selectedTimes[day].start
                      ? selectedTimes[day].start.unix()
                      : "",
                    end_time: selectedTimes[day].end
                      ? selectedTimes[day].end.unix()
                      : "",
                  })
                );

                // Merge formatted availability into form values
                const payload = {
                  ...valuesData,
                  availability: formattedAvailability,
                  profile_image: [image],
                  // provider: selectedOption?._id,
                };
                const userData = await API_UPDATE_LAUNDRY_MEN(
                  payload,
                  driver?._id
                );
                Navigate("/admin/laundryman-management/laundryman-tables");

                toast.success(userData?.message);
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                // setSubmitting(false);
              }
            }}
          >
            <div
              className="flex items-center"
              style={{ flexDirection: "column" }}
            >
              {console.log(image, "fhlasdjh98o768i75 8")}
              {console.log(valuesData, "valuesData")}
              <div>
                <p className="mb-1 font-bold">Save Changes</p>
                <p className="mb-8 font-medium">
                  Do you want to Save Changes before leaving the Page?
                </p>
              </div>
              <div className="flex gap-4">
                <button
                  className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={() => setConfirmModalVisible(false)}
                  style={{ width: "6rem" }}
                >
                  Cancel
                </button>
                <button
                  className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={async () => {
                    setConfirmModalVisible(false);
                    try {
                      if (valuesData.laundry_man_type === "truck_driver") {
                        if (
                          !valuesData.pickup_order_rate_from_store_to_laundry
                        ) {
                        }
                        if (
                          !valuesData.pickup_order_rate_from_laundry_to_store
                        ) {
                        }
                      } else {
                        delete valuesData.pickup_order_rate_from_store_to_laundry;
                        delete valuesData.pickup_order_rate_from_laundry_to_store;
                      }
                      const formattedAvailability = Object.keys(
                        selectedTimes
                      ).map((day) => ({
                        day,
                        start_time: selectedTimes[day].start
                          ? selectedTimes[day].start.unix()
                          : "",
                        end_time: selectedTimes[day].end
                          ? selectedTimes[day].end.unix()
                          : "",
                      }));
                      const payload = {
                        ...valuesData,
                        availability: formattedAvailability,
                        profile_image: Array.isArray(image) ? image : [image],
                        // provider: selectedOption?._id,
                      };
                      const userData = await API_UPDATE_LAUNDRY_MEN(
                        payload,
                        driver?._id
                      );
                      Navigate(
                        "/admin/laundryman-management/laundryman-tables"
                      );
                      toast.success(userData?.message);
                    } catch (error) {
                      console.error("error", error);
                      toast.error(error?.response?.data?.message);
                    } finally {
                    }
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default EditLaundryMan;
